import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Collections from "@/pages/Collections";
import CustomOrders from "@/pages/CustomOrders";
import Queries from "@/pages/Queries";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import "@/App.css";

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    const lenis = new Lenis({ duration: 1.1, easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)) });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const token = localStorage.getItem("arkaari_token");
  return token ? children : <Navigate to="/admin/login" replace />;
}

const Site = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <Toaster position="bottom-right" theme="dark" />
      <Routes>
        <Route path="/" element={<Site><Home /></Site>} />
        <Route path="/about" element={<Site><About /></Site>} />
        <Route path="/collections" element={<Site><Collections /></Site>} />
        <Route path="/custom-orders" element={<Site><CustomOrders /></Site>} />
        <Route path="/queries" element={<Site><Queries /></Site>} />
        <Route path="/contact" element={<Site><Contact /></Site>} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
